import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import process from './process'
import users from './users'
import archive from './archive'


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    users,
    process,
    archive
  }
})
